// extracted by mini-css-extract-plugin
export default {"fadein":"Dialog_fadein__MAqsO","fadeout":"Dialog_fadeout__CV2rB","grow":"Dialog_grow__vW6f4","shrink":"Dialog_shrink__+9SDe"};